import './ResetPassword.scss';
import Component from './ResetPassword.js';
export default Component;
